import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M7.058 3.058a.625.625 0 0 1 .884 0l4 4a.625.625 0 1 1-.884.884L8.125 5.009V20.5a.625.625 0 1 1-1.25 0V5.009L3.942 7.942a.625.625 0 1 1-.884-.884l4-4Zm8.817.442a.625.625 0 1 1 1.25 0v15.491l2.933-2.933a.625.625 0 1 1 .884.884l-4 4a.625.625 0 0 1-.884 0l-4-4a.625.625 0 1 1 .884-.884l2.933 2.933V3.5Z"
    />
  </svg>
`;
